/**
 * 学生管理 API
 */
import { request, buildUrl } from './request'

function serializeStudentPayload(data) {
  if (data instanceof FormData) return data
  return JSON.stringify(data)
}

/**
 * 获取学生列表，支持按班级/年级/姓名等筛选
 * @param {object} params - { class_id?, grade_id?, grade?, gender?, include_all?, student_name?, page?, page_size? }
 * 响应项应包含 gender: 0-未设置 1-男 2-女
 */
export function getStudents(params = {}) {
  const url = buildUrl('/api/students', {
    class_id: params.class_id,
    grade_id: params.grade_id,
    grade: params.grade,
    gender: params.gender,
    include_all: params.include_all,
    student_name: params.student_name,
    page_size: params.page_size,
    page: params.page
  })
  return request(url)
}

/**
 * 根据 ID 获取学生
 * @param {string} id - 学生 ID (student_id)
 * 响应项应包含 gender: 0-未设置 1-男 2-女
 */
export function getStudent(id) {
  return request(`/api/students/${id}`)
}

/**
 * 创建学生
 * @param {object} data - { user_id?, student_number?, class_id?, student_phone?, card?, name?, ding_id?, gender?, is_commuter?, create_by? }
 * gender: 0-未设置 1-男 2-女
 * is_commuter: 0-住宿生 1-通校生
 */
export function createStudent(data) {
  return request('/api/students', {
    method: 'POST',
    body: serializeStudentPayload(data)
  })
}

/**
 * 更新学生
 * @param {string|number} id - 学生主键 ID (student_id)，不是 user_id
 * @param {object} data - { user_id?, student_number?, class_id?, student_phone?, card?, name?, ding_id?, gender?, is_commuter?, update_by? }
 */
export function updateStudent(id, data) {
  return request(`/api/students/${id}`, {
    method: 'PUT',
    body: serializeStudentPayload(data)
  })
}

/**
 * 删除学生
 * @param {string} id - 学生 ID
 */
export function deleteStudent(id) {
  return request(`/api/students/${id}`, {
    method: 'DELETE'
  })
}
